import { MouseEvent } from 'react'
import styled, { css } from 'styled-components'
import Box from 'components/Box'
import { tone } from 'utils'

type VersionLabelProps = {
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void
}

const VersionLabel = styled(Box)<VersionLabelProps>(
  ({ theme }) => css`
    text-transform: uppercase;
    border-radius: 3px;
    font-size: 0.625rem;
    background-color: ${theme.colors.primaryTint[100]};
    color: ${theme.colors.text.light.base};
    padding: 4px 12px 4px 32px;
    font-weight: ${theme.fontWeights.bold};
    position: relative;
    white-space: nowrap;

    &:hover {
      color: ${theme.colors.text.light.base};
    }

    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 24px;
      height: 100%;
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
      background-color: ${tone(-2, theme.colors.primaryTint[100])};
    }

    &:after {
      content: '';
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: ${theme.colors.background.light.base};
      position: absolute;
      left: 8px;
      top: 0;
      bottom: 0;
      margin: auto 0;
    }
  `
)

export default VersionLabel
